import React from 'react';
import { connect } from 'react-redux';
import { getSafe } from '@/helpers/global';
import icon_check_normalIcon from '@/assets/images/icons/icon_check_normal.png';
import icon_check_hitIcon from '@/assets/images/icons/icon_check_hit.png';
import Tips from '../../../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
class ApplyProspectus extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      prospectus: [
        {
          id: 0,
          value: false,
          label: 'ipo_apply_prospectus_one'
        },
        {
          id: 1,
          value: false,
          label: 'ipo_apply_prospectus_two'
        },
        {
          id: 2,
          value: false,
          label: 'ipo_apply_prospectus_three'
        },
        {
          id: 3,
          value: false,
          label: 'ipo_apply_prospectus_four'
        }
      ]
    }
  }

  changeProspectus = (index) => {
    let data = this.state.prospectus
    data[index].value = !this.state.prospectus[index].value
    this.setState({
      prospectus: data
    })
  }

  ref(e){
    const {applyDataResp, language} = this.props
    e.stopPropagation()
    if(applyDataResp){
      if(language.title === 'zh_TW' || language.title === 'zh_CN'){
        if(applyDataResp.chineseProspectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.chineseProspectus;
        }else if(applyDataResp.prospectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.prospectus;
        }
      }else{
        if(applyDataResp.prospectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.prospectus;
        }
      }
    }
  }

  render() {
    const { language, fail } = this.props;
    const { prospectus } = this.state;
    return (
      <React.Fragment>
        <section className='prospectus-container'>
          {
            fail && <Tips isNoBgColor type={tipsType.error} style={{ fontSize: '20px' }}>
              {language.ipo_apply_prospectus_tips}
            </Tips>
          }

          <div className="title">
            {getSafe(() => language.ipo_apply_prospectus_title)}
          </div>
          <div className="content">
            {
              prospectus.map((item, index) =>
              index === 0 ? 
              <div key={item.id} className="option" onClick={() => this.changeProspectus(index)}>
                <label><img src={item.value ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
                <div>{getSafe(() => language.ipo_apply_prospectus_one_a)}
                <b onClick={e =>this.ref(e)} className='prospectus'>{getSafe(() => language.ipo_apply_prospectus_one_b)}</b>
                  {
                    (language.title === 'zh_TW' || language.title === 'zh_CN') ?
                  <React.Fragment>
                    {getSafe(() => language.ipo_apply_prospectus_one_c)}
                    <b onClick={e =>this.ref(e)} className='prospectus'>{getSafe(() => language.ipo_apply_prospectus_one_b)}</b>
                    {getSafe(() => language.ipo_apply_prospectus_one_d)}
                  </React.Fragment>
                  :
                  getSafe(() => language.ipo_apply_prospectus_one_c)
                  }
                </div>
              </div> : 
              <div key={item.id} className="option" onClick={() => this.changeProspectus(index)}>
                <label><img src={item.value ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
                <div>{getSafe(() => language[item.label])}</div>
              </div>
              )
            }
          </div>
        </section>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(ApplyProspectus)
